'use client';
import { useNookContext } from '@/components/providers/NookContextProvider';
import CreateNookForm from './CreateNookForm';

const ClaimNookForm = () => {
  const { id } = useNookContext();
  return (
    <div className='flex flex-col gap-2'>
      <p>
        The nook: <span className='text-green-700 font-bold'>{id}</span> has not
        yet been claimed. Click the button below to make it your own.
      </p>
      <CreateNookForm {...(id ? { presetId: id } : {})} />
    </div>
  );
};

export default ClaimNookForm;

// The nook: ${id} has not yet been claimed.
